/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_44a05247{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.root_44a05247 .dropdown_44a05247{margin-bottom:0;margin-left:5px}\n"}]);
export const root = "root_44a05247";
export const dropdown = "dropdown_44a05247";